export const COLORS = {
  brand: {
    white: '#F4F7F6',
    light: '#F1F9BC',
    bright: '#57B5AB',
    medium: '#717C26',
    dark: '#474D22',
    black: '#000000',
  },
  status: {
    success: '#218105',
    error: '#EF4444',
    info: '#57B5AB',
    warning: '#F59E0B',
  },
  channel: {
    edi: '#474D22',
    ebill: '#474D22',
    email: '#57B5AB',
    print: '#717C26',
  }
};

export const RADII = {
  standard: 'rounded-[10px]',
  large: 'rounded-[14px]',
  xlarge: 'rounded-[18px]',
  massive: 'rounded-[22px]',
};

export const SHADOWS = {
  sm: 'shadow-sm',
  md: 'shadow-md',
  lg: 'shadow-lg',
  xl: 'shadow-xl',
  inner: 'shadow-inner',
};

export const TRANSITIONS = 'transition-all duration-300 ease-in-out';